import { useParams, useNavigate } from 'react-router-dom';
import PageHeader from '../../molecules/PageHeader';
import NewTooltip from '../../atoms/NewTooltip';
import BatchProcessingList from './BatchProcessingList';
import HistoryView from './HistoryView';

export default function CreditAnalysisMain() {
    const { tab } = useParams<{ tab?: string }>();
    const navigate = useNavigate();
    const activeTab = tab || 'processamentos';

    const handleTabChange = (newTab: string) => {
        navigate(`/credit-analysis/${newTab}`);
    };

    return (
        <div className="bg-white dark:bg-slate-800 h-screen overflow-hidden flex flex-col">
            {/* Header comum para todas as tabs */}
            <div className="px-4 pt-4">
                <PageHeader 
                    title="Análise de Crédito" 
                    apiVersion="Credit Analysis API - 1.0.0" 
                    breadcrumb={[{ label: 'Análise de Crédito', url: '#' }]}
                >
                    <div className="pt-6">
                        <NewTooltip content='Iniciar novo processamento' alignment='left'>
                            <button
                                id="btn-new-batch"
                                className='text-white bg-blue-500 hover:bg-blue-700 dark:bg-blue-600 dark:hover:bg-blue-700 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-400 font-medium rounded text-sm px-5 py-2.5 text-center'
                                onClick={() => navigate('/credit-analysis/form')}
                            >
                                Novo processamento
                            </button>
                        </NewTooltip>
                    </div>
                </PageHeader>
            </div>

            {/* Tabs */}
            <div className="border-b border-gray-200 dark:border-slate-600 px-4">
                <nav className="flex" aria-label="Tabs">
                    <button
                        onClick={() => handleTabChange('processamentos')}
                        className={`py-4 px-6 text-sm font-medium border-b-2 transition-colors ${
                            activeTab === 'processamentos'
                                ? 'border-blue-500 text-blue-600 dark:text-blue-400'
                                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-300'
                        }`}
                    >
                        Processamentos
                    </button>
                    <button
                        onClick={() => handleTabChange('historico')}
                        className={`py-4 px-6 text-sm font-medium border-b-2 transition-colors ${
                            activeTab === 'historico'
                                ? 'border-blue-500 text-blue-600 dark:text-blue-400'
                                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300 dark:text-gray-400 dark:hover:text-gray-300'
                        }`}
                    >
                        Histórico de Análises
                    </button>
                </nav>
            </div>

            {/* Conteúdo das tabs */}
            <div className="flex-1 min-h-0 overflow-hidden">
                {activeTab === 'processamentos' && <BatchProcessingList />}
                {activeTab === 'historico' && <HistoryView />}
            </div>
        </div>
    );
}
